"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var BugIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(BugIcon, _React$PureComponent);

  function BugIcon() {
    _classCallCheck(this, BugIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(BugIcon).apply(this, arguments));
  }

  _createClass(BugIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'bug-icon')
      }, props), _react.default.createElement("g", null, _react.default.createElement("path", {
        fill: color,
        d: "M8.0986,1.8672 L8.4396,1.2392 C8.5716,0.9962 8.4816,0.6922 8.2386,0.5612 C7.9966,0.4302 7.6936,0.5182 7.5606,0.7622 L7.2716,1.2942 C6.8846,1.1122 6.4566,1.0002 5.9996,1.0002 C5.5356,1.0002 5.1026,1.1162 4.7106,1.3042 L4.4476,0.7772 C4.3236,0.5292 4.0246,0.4302 3.7766,0.5532 C3.5296,0.6772 3.4296,0.9772 3.5526,1.2242 L3.8836,1.8862 C3.4006,2.3692 3.0766,3.0112 3.0116,3.7312 C2.9986,3.8762 3.1226,4.0002 3.2676,4.0002 L8.7326,4.0002 C8.8766,4.0002 9.0006,3.8762 8.9886,3.7312 C8.9236,3.0022 8.5916,2.3522 8.0986,1.8672"
      }), _react.default.createElement("path", {
        fill: color,
        d: "M10.7803,8.2202 C10.6393,8.0792 10.4493,8.0002 10.2503,8.0002 L10.0003,8.0002 L10.0003,6.5002 L10.2513,6.5002 C10.4503,6.5002 10.6403,6.4212 10.7813,6.2802 L11.7803,5.2802 C12.0733,4.9872 12.0733,4.5122 11.7803,4.2192 C11.4863,3.9262 11.0113,3.9282 10.7193,4.2202 L10.0873,4.8532 C9.9933,4.9472 9.8663,5.0002 9.7333,5.0002 L8.2503,4.9992 C8.2493,4.9992 8.2483,5.0002 8.2483,5.0002 L7.0003,5.0002 C6.7233,5.0002 6.5003,5.2232 6.5003,5.5002 L6.5003,11.6482 C6.5003,11.8042 6.6453,11.9312 6.7993,11.9002 C8.1193,11.6322 9.1973,10.7172 9.6963,9.5002 L9.8353,9.5002 C9.9013,9.5002 9.9663,9.5272 10.0133,9.5742 L10.7193,10.2812 C10.8663,10.4272 11.0573,10.5002 11.2503,10.5002 C11.4423,10.5002 11.6343,10.4272 11.7803,10.2812 C12.0733,9.9882 12.0733,9.5132 11.7803,9.2202 L10.7803,8.2202 Z"
      }), _react.default.createElement("path", {
        fill: color,
        d: "M5,5 L2.5,5 C2.479,5 2.463,5.009 2.443,5.011 L2.271,5.01 C2.14,5.009 2.014,4.956 1.92,4.863 L1.282,4.221 C0.99,3.927 0.514,3.926 0.222,4.218 C-0.072,4.51 -0.074,4.985 0.218,5.279 L1.219,6.285 C1.358,6.426 1.548,6.505 1.746,6.507 L2,6.509 L2,8 C2,8.003 2.001,8.006 2.001,8.009 L1.756,8.007 C1.586,8.025 1.365,8.084 1.223,8.225 L0.222,9.218 C-0.072,9.51 -0.074,9.985 0.218,10.279 C0.364,10.427 0.557,10.5 0.75,10.5 C0.941,10.5 1.132,10.428 1.278,10.283 L1.982,9.583 C2.03,9.536 2.096,9.51 2.163,9.51 L2.309,9.511 C2.81,10.722 3.885,11.633 5.201,11.9 C5.355,11.932 5.5,11.805 5.5,11.648 L5.5,5.5 C5.5,5.224 5.275,5 5,5"
      })));
      /* eslint-enable max-len */
    }
  }]);

  return BugIcon;
}(_react.default.PureComponent);

exports.default = BugIcon;
BugIcon.defaultProps = {
  color: 'inherit'
};
BugIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};